import styled from "styled-components";

const DEFAULT_COLORS = ["#1E22FF", "#6366FF", "#9194FF", "#AEB0FF", "#D2D3FF"];

const renderChannelColor = (theme, selectedChannel, currentChannel, index) => {
  const channelIsSelected = currentChannel === selectedChannel;

  if (!selectedChannel) {
    return DEFAULT_COLORS[index % DEFAULT_COLORS.length];
  }

  if (selectedChannel && !channelIsSelected) {
    return theme.colors.dataViz.secondaryBoxIconBackground;
  }

  if (channelIsSelected) {
    return DEFAULT_COLORS[0];
  }
};

const fillSVGColor = (theme, selectedChannel, currentChannel, index) => {
  const isDarkBackground = index < 3;
  const channelIsSelected = currentChannel === selectedChannel;

  if (channelIsSelected || !selectedChannel) {
    if (isDarkBackground || channelIsSelected) {
      return "white";
    }
  }

  return "";
};

export const Options = styled.div`
  display: flex;
  gap: 40px;
  cursor: pointer;
  min-width: fit-content;
`;

export const OptionsChannels = styled.div`
  font-size: 11px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colors.dataViz.primaryMetricTitleColor};
`;

export const ChannelIcon = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ChannelIconWrapper = styled.div`
  padding: 3px;
`;

export const BoxIcon = styled.div`
  border-radius: 3px;
  width: 20px;
  height: 20px;
  background-color: ${({ theme, selectedChannel, currentChannel, index }) =>
    renderChannelColor(theme, selectedChannel, currentChannel, index)};

  > div > svg > path {
    fill: ${({ theme, selectedChannel, currentChannel, index }) =>
      fillSVGColor(theme, selectedChannel, currentChannel, index)};
  }
`;
